import React, { useEffect, useState } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import '../../TargetReport/TableContent/index.css';
import './operations.css';
import { Height } from '@material-ui/icons';
import { ListItemText, TableFooter, Tooltip, Typography } from '@material-ui/core';

function TableContent({ tableData, headerData, totalTableData, totalTableColumn, totalTableRow }) {
  const [model, setModel] = useState();
  const [header, setHeader] = useState({
    mes1Nome: '',
    mes2Nome: '',
    mes3Nome: '',
    mesMetaNome: '',
    dataHora: '',
    mediaCrescimento: '',
  });
  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const toCurrency = (e) => {
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span></span>
          <span>{e ? formatter.format(e) : '0,00'}</span>
        </div>
      </>
    );
  };

  useEffect(() => {
    if (headerData) {
      setHeader({
        mesReferencia: headerData.mesReferencia,
        mesPrincipal: headerData.mesPrincipal,
      });
    }
  }, [headerData]);

  const tooltipTitleTable = (item) => {
    return (
      <React.Fragment>
        <Table size="small">
          <TableRow>
            <TableCell style={{ color: 'white' }}>Nunca Antecipou:</TableCell>
            <TableCell style={{ color: 'white' }}>{toCurrency(item.nuncaAntecipou)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ color: 'white' }}>De 1 a 30:</TableCell>
            <TableCell style={{ color: 'white' }}>{toCurrency(item.de1a30)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ color: 'white' }}>De 31 a 90:</TableCell>
            <TableCell style={{ color: 'white' }}>{toCurrency(item.de31a90)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ color: 'white' }}>Maior Que 90:</TableCell>
            <TableCell style={{ color: 'white' }}>{toCurrency(item.maiorQue90)}</TableCell>
          </TableRow>
        </Table>
      </React.Fragment>
    );
  };

  const tooltipTitleTableTotal = (item) => {
    return (
      <React.Fragment>
        <Table size="small">
          <TableRow>
            <TableCell style={{ color: 'white' }}>Nunca Antecipou:</TableCell>
            <TableCell style={{ color: 'white' }}>
              {toCurrency(item.totalGeralNuncaAntecipou)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ color: 'white' }}>De 1 a 30:</TableCell>
            <TableCell style={{ color: 'white' }}>{toCurrency(item.totalGeralDe1a30)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ color: 'white' }}>De 31 a 90:</TableCell>
            <TableCell style={{ color: 'white' }}>{toCurrency(item.totalGeralDe31a90)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ color: 'white' }}>Maior Que 90:</TableCell>
            <TableCell style={{ color: 'white' }}>
              {toCurrency(item.totalGeralMaiorQue90)}
            </TableCell>
          </TableRow>
        </Table>
      </React.Fragment>
    );
  };

  const dataTable = totalTableRow?.map(function (item, index) {
    let backColor = 'white';
    if (index % 2) {
      backColor = '#EEEEEE';
    }
    return (
      <>
        <TableRow key={item.index} style={{ backgroundColor: backColor }}>
          <TableCell align="left">{item.rede}</TableCell>
          {tableData
            ?.filter((e) => e.ancoraId === item.ancoraId)
            .map((bitem, bindex) => {
              return (
                <Tooltip key={bindex} title={tooltipTitleTable(bitem)} arrow>
                  <TableCell align="right">{toCurrency(bitem.total)}</TableCell>
                </Tooltip>
              );
            })}
          <Tooltip key={item.ancoraId} title={tooltipTitleTable(item)} arrow>
            <TableCell style={{ backgroundColor: '#C4C4C4' }} align="right">
              {toCurrency(item.mediaLinha)}
            </TableCell>
          </Tooltip>
        </TableRow>
      </>
    );
  });

  const dataFooter = totalTableColumn?.map(function (item, index) {
    return (
      <Tooltip key={item.ancoraId} title={tooltipTitleTable(item)} arrow>
        <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="right">
          {toCurrency(item.totalColuna)}
        </TableCell>
      </Tooltip>
    );
  });

  const dateHeaderColumn = totalTableColumn?.map(function (item, index) {
    const data = new Date(item.dataVolume);
    return (
      <>
        <TableCell
          style={{ color: 'white', fontWeight: 'bold' }}
          key={item.ancoraId}
          align="center"
        >
          {data.toLocaleDateString()}
        </TableCell>
      </>
    );
  });

  return (
    <>
      <div
        className="report-tables"
        style={{
          margin: '0px 45px 0px 50px',
          zIndex: '0',
          position: 'relative',
          justifyContent: 'start',
          flexWrap: 'wrap',
          display: headerData ? 'flex' : 'none',
          overflowX: 'auto',
        }}
      >
        <Table
          style={{
            backgroundColor: 'white',
            marginBottom: '20px',
            boxShadow:
              '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
          }}
        >
          <TableHead style={{ backgroundColor: '#232C63' }}>
            <TableRow>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Rede
              </TableCell>
              {dateHeaderColumn}
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Média
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataTable}
            <TableRow>
              <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                Total
              </TableCell>
              {dataFooter}
              {headerData && (
                <Tooltip key={'total'} title={tooltipTitleTableTotal(headerData)} arrow>
                  <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="right">
                    {toCurrency(headerData.totalGeral)}
                  </TableCell>
                </Tooltip>
              )}
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <div
        style={{
          marginTop: '20px',
          zIndex: '0',
          position: 'relative',
          justifyContent: 'start',
        }}
      ></div>
    </>
  );
}

export default TableContent;
